import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from "./components/LandingPage/Home";
import DataCollect from './components/data-forms/DataCollect';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route exact path='/' element={< Home />}></Route>
          <Route exact path='/datacollect' element={< DataCollect />}></Route>
          {/* <Route exact path='/datacollect' element={< DownloadForm />}></Route> */}
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
